import { resolveJurisdictionPack } from "../domain/jurisdiction-packs";
import type { MatterDraft } from "./ui-types";

const browserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
};

export const blankMatterDraft = (
  defaultJurisdictionPackId?: string | null,
  defaultSpeakerName?: string | null
): MatterDraft => ({
  title: "",
  reference: "",
  proceeding: "Conference",
  jurisdictionPack: resolveJurisdictionPack(defaultJurisdictionPackId).pack.id,
  venue: "",
  date: new Date().toISOString().slice(0, 10),
  timezone: browserTimezone(),
  languages: ["English"],
  participants: defaultSpeakerName?.trim()
    ? [{ name: defaultSpeakerName.trim(), role: "Recorder" }]
    : [],
  glossary: [],
  authorityReference: "",
  authority: {
    userAttestation: false,
    participantNotice: false,
    participantConsent: false,
    confidentialityReviewed: false,
    courtApproval: false
  }
});

export const seedDefaultSpeaker = (
  matter: MatterDraft,
  defaultSpeakerName?: string | null
): MatterDraft => {
  const name = defaultSpeakerName?.trim();
  if (!name || matter.participants.length > 0) return matter;
  return {
    ...matter,
    participants: [{ name, role: "Recorder" }]
  };
};
